export enum NewsletterCampaignStatus {
  Draft = 0,
  Prepared = 1,
  Generated = 2,
  Scheduled = 3,
  Sending = 4,
  Sent = 5,
  Declined = 6,
}

export const newsletterCampaignStatusTranslations: Record<NewsletterCampaignStatus, string> = {
  [NewsletterCampaignStatus.Draft]: 'newsletter.status.draft',
  [NewsletterCampaignStatus.Prepared]: 'newsletter.status.prepared',
  [NewsletterCampaignStatus.Generated]: 'newsletter.status.generated',
  [NewsletterCampaignStatus.Scheduled]: 'newsletter.status.scheduled',
  [NewsletterCampaignStatus.Sending]: 'newsletter.status.sending',
  [NewsletterCampaignStatus.Sent]: 'newsletter.status.sent',
  [NewsletterCampaignStatus.Declined]: 'newsletter.status.declined',
};

/** A campaign that never went out; the backend keeps anything later for the audit trail. */
export const newsletterCampaignDeletableStatuses: NewsletterCampaignStatus[] = [
  NewsletterCampaignStatus.Draft,
  NewsletterCampaignStatus.Prepared,
  NewsletterCampaignStatus.Declined,
];

export const newsletterCampaignStatusOptions = [
  { text: newsletterCampaignStatusTranslations[NewsletterCampaignStatus.Draft], val: NewsletterCampaignStatus.Draft },
  {
    text: newsletterCampaignStatusTranslations[NewsletterCampaignStatus.Prepared],
    val: NewsletterCampaignStatus.Prepared,
  },
  {
    text: newsletterCampaignStatusTranslations[NewsletterCampaignStatus.Generated],
    val: NewsletterCampaignStatus.Generated,
  },
  {
    text: newsletterCampaignStatusTranslations[NewsletterCampaignStatus.Scheduled],
    val: NewsletterCampaignStatus.Scheduled,
  },
  {
    text: newsletterCampaignStatusTranslations[NewsletterCampaignStatus.Sending],
    val: NewsletterCampaignStatus.Sending,
  },
  { text: newsletterCampaignStatusTranslations[NewsletterCampaignStatus.Sent], val: NewsletterCampaignStatus.Sent },
  {
    text: newsletterCampaignStatusTranslations[NewsletterCampaignStatus.Declined],
    val: NewsletterCampaignStatus.Declined,
  },
];
